import React from 'react';
import Pagination from "rc-pagination";
import { locale } from "../../common/table/paginatorConfig";
import { Spinner } from "react-bootstrap";
import { IPageResponse, SortDirection } from 'common/interfaces/IPageResponse';
import { SortIcons } from 'components/SortIcons/SortIcons';
import { CustomerEnergyAgreement, EnergyAgreementSortFields } from './model';

interface EnergyAgreementsTableProps {
  energyAgreements?: IPageResponse<CustomerEnergyAgreement>;
  isRequesting: boolean;
  onPageChange: (page: number, pageSize: number) => void;
  onSort: (sortField: EnergyAgreementSortFields) => void;
  sortField: EnergyAgreementSortFields;
  sortDirection: SortDirection;
}

export function EnergyAgreementsTable(props: EnergyAgreementsTableProps) {
    const energyAgreements: Array<CustomerEnergyAgreement> = props.energyAgreements ? props.energyAgreements.content : [];
    const pageResponse = props.energyAgreements;

    const tableRows = energyAgreements.map((energyAgreement: CustomerEnergyAgreement) => {
            return (
                <tr key={'row-' + energyAgreement.id}>
                  <td>
                    {energyAgreement.id}
                  </td>
                  <td>
                      {energyAgreement.customer.name}
                  </td>
                  <td>
                      {energyAgreement.customer.registryNumber}
                  </td>
                  <td>
                      {energyAgreement?.customer.groupId}
                  </td>
                  <td>
                      {energyAgreement?.name}
                  </td>
                  <td>
                      {energyAgreement?.startDate}
                  </td>
                  <td>
                      {energyAgreement?.endDate}
                  </td>
              </tr>
            );
        }
    );

    return (
        <>
            <table className='customer-contact-persons__table table table-responsive-lg table-hover'>
                <thead>
                <tr>
                    <th>Id</th>
                    <th className="sort-down-up-hover">
                      <div className="d-flex align-items-center"
                          onClick={() => props.onSort(EnergyAgreementSortFields.NAME)}>
                          <span>Nimi</span>
                          <SortIcons
                              sortedByField={props.sortField}
                              sortDirection={props.sortDirection}
                              currentSortColumn={EnergyAgreementSortFields.NAME} />
                      </div>
                    </th>             
                    <th className="sort-down-up-hover">
                      <div className="d-flex align-items-center"
                          onClick={() => props.onSort(EnergyAgreementSortFields.REGISTRY_NUMBER)}>
                          <span>Isikukood</span>
                          <SortIcons
                              sortedByField={props.sortField}
                              sortDirection={props.sortDirection}
                              currentSortColumn={EnergyAgreementSortFields.REGISTRY_NUMBER} />
                      </div>
                    </th>  
                    <th>Kliendi grupp</th>        
                    <th>Paketi nimi</th>       
                    <th>Paketi algus</th>       
                    <th>Paketi lõpp</th>
                </tr>
                </thead>
                <tbody>
                    {props.isRequesting ?
                    <tr>
                        <td colSpan={10} className="spinner-cell">
                            <div className="p-4 w-100 d-flex align-items-center justify-content-center">
                                <Spinner animation="grow" />
                            </div>
                        </td>
                    </tr> :
                    tableRows}
                </tbody>
                {pageResponse ? <tfoot>
                <tr>
                    <td colSpan={10}>
                        <div className="pagination-wrapper">
                            <Pagination
                                locale={locale}
                                current={pageResponse.number + 1}
                                total={pageResponse.totalElements}
                                pageSize={pageResponse.size}
                                prefixCls={"pagination"}
                                onChange={props.onPageChange}
                                showSizeChanger={false}
                                hideOnSinglePage={true}
                            />
                        </div>
                    </td>
                </tr>
                </tfoot> : null}
            </table>
        </>
    )
}